import { captureSentryMessage } from '@shared/sentry';
import { reloadChromeRuntimeIfPossible, setLocalStorage } from '../utils';

export function startHandlingUpdateAvailable(): void {
  captureSentryMessage('Starting to handle update available');
  chrome.runtime.onUpdateAvailable.addListener(async () => {
    captureSentryMessage('Update available detected');
    await setLocalStorage('isUpdateAvailable', true);
    await reloadChromeRuntimeIfPossible();
  });
}
